// extracted by mini-css-extract-plugin
export default {"sampleProfilesBlock":"SampleProfilesTab_sampleProfilesBlock__nmR35","link":"SampleProfilesTab_link__piJWx"};